export const deviceFields = [
  {
    label: 'IMEI',
    key: 'imei',
  },
  {
    label: 'Nomor Simcard',
    key: 'phone_no',
  },
  {
    label: 'Kode Perangkat',
    key: 'device_code',
  },
].map((field) => ({
  ...field,
  isSortable: true,
  showErrorKey: field.key,
  thAttr: {
    style: 'min-width:180px;',
  },
}))
